import React, { useEffect, useRef } from "react";
import useScenarioQuestions from "../../hooks/useScenarioQuestions";
import { DndProvider } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";
import { CustomDragLayer } from "../ScenarioQuestions/CustomDragLayer";

import "./Scenario.scss";
import "../ScenarioQuestions/ScenarioQuestions.scss";
import { initCheckAffiliate, initScenarios } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import useNavigation from "../../hooks/useNavigation";
import useAffiliateCodeModal from "../../hooks/useAffiliateCodeModal";
import { AffiliateCodeModal, ChoosePlanFirstModal } from "../../modals";
import { useNavigate } from "react-router-dom";
import { isAccessFeature } from "../../common/utils";
const Scenario = () => {
  const dispatch = useDispatch();
  const { scenarioId, mappingArray } = useScenarioQuestions();
  const { user } = useNavigation();
  const navigate = useNavigate();
  const {
    affiliateCodeModal,
    choosePlanFirstOpen,
    closeAffiliateCodeModal,
    closeChoosePlanFirstModal,
    confirmChoosePlanFirstModal,
    openAffiliateCodeModal,
    setAffiliateCode,
    submitAffiliateCode,
  } = useAffiliateCodeModal(user);

  const isErrorPricing = isAccessFeature(user).plan_active;
  useEffect(() => {
    if (!isErrorPricing) {
      openAffiliateCodeModal();
    }
  }, [isErrorPricing]);
  useEffect(() => {
    dispatch(initScenarios());
  }, [dispatch]);
  return (
    mappingArray[scenarioId] &&
    mappingArray[scenarioId]?.component && (
      <DndProvider options={HTML5toTouch}>
        <ChoosePlanFirstModal
          isOpened={choosePlanFirstOpen}
          onClose={closeChoosePlanFirstModal}
          onContinue={confirmChoosePlanFirstModal}
        />
        {affiliateCodeModal.isOpened ? (
          <section className="Scenario1">
            <AffiliateCodeModal
              {...affiliateCodeModal}
              onBack={() => {
                closeAffiliateCodeModal();
                navigate(-1);
              }}
              onChange={setAffiliateCode}
              onPricingPlanClick={() => {
                closeAffiliateCodeModal();
                navigate(isErrorPricing ? "/scenario/0" : "/pricingplan");
              }}
              onSubmit={submitAffiliateCode}
            />
          </section>
        ) : (
          <>
            <section className={mappingArray[scenarioId]?.className}>
              {mappingArray[scenarioId]?.component}
            </section>
            <CustomDragLayer scenarioId={mappingArray[scenarioId].scenarioId} />
          </>
        )}
      </DndProvider>
    )
  );
};

export default Scenario;
